import {AfterViewInit, Component, HostListener, NgZone, OnDestroy, OnInit, ViewChild, Input, EventEmitter, Output} from '@angular/core';
import {InfluencerGroup} from '../../../models/influencer-group';
import {GroupService} from '../../services/group-details/group.service';
import {Country} from '../../../models/country';
import {Platform} from '../../../models/platform';
import {CampaignInfluencerStatus, CommonConstant, RecentlyVisitedInfluencerGroup, InfluencerGroupStatus} from '../../app.constants';
import {Influencer} from '../../../models/influencer';
import {ActivatedRoute, Router} from '@angular/router';
import {ReferenceDataService} from '../../services/reference-data/reference-data.service';
import {GroupSearch} from '../../../models/group-search';
import {UserService} from '../../services/user.service';
import {ModalService} from '../../services/modal/modal.service';
import {AchooPopupComponent} from '../../core/achoo-popup/achoo-popup.component';
import {CampaignService} from '../../services/campaign/campaign.service';
import {InfluencerGroupsService} from '../influencer-groups/influencer-groups.service';
import {PlaceholderVisibilityService} from '../../services/placeholder-visibility/placeholder-visibility.service';
import {Subscription} from 'rxjs/Subscription';
import {AbstractAchooComponent} from '../abstract-achoo.component';
import {Location as NgCommonLocation} from '@angular/common';
import {
  ActionDetails,
  ActionSource,
  ActivePages,
  EventTrackerService,
  Page,
  TargetType,
  UserActionType
} from '../../services/event-tracker/event-tracker.service';
import {CacheService} from '../../services/cache/cache.service';
import {InfluencerService} from '../../services/influencer/influencer.service';
import {TranslateService} from '@ngx-translate/core';
import {ObjectUtils} from '../../utils/object.utils';
import * as Sentry from '@sentry/browser';
import {AppSettings} from '../../utils/app-settings';
import {WebUtils} from '../../utils/web.utils';
import {InvalidAction} from '../../../models/user';
import {ActivePage} from '../../../models/event-tracker';
import {GroupDetailsBreadcumbComponent} from './group-details-breadcumb/group-details-breadcumb.component';
import {BottombarInfluencerFragementComponent} from '../bottombar-influencer-fragement/bottombar-influencer-fragement.component';
import {GroupVersion, NewInfluencerGroup} from '../../../models/auto-group/auto-group-setting';

@Component({
  selector: 'group-details',
  templateUrl: './group-details.component.html',
  styleUrls: ['./group-details.component.scss']
})
export class GroupDetailsComponent extends AbstractAchooComponent implements OnInit, OnDestroy, AfterViewInit {
  static INFLUENCER_DETAILS_LIST_KEY = 'influencer_details_list';
  private readonly INTERNATIONAL_COUNTRY_ID = 250;

  @ViewChild('WarningDeleteInfluencerDialog')
  public warningDeleteInfluencerDialog: AchooPopupComponent;
  @ViewChild('AlertAPIError')
  public serverErrorNotification: AchooPopupComponent;
  @ViewChild('SuccessNotification')
  public successNotification: AchooPopupComponent;
  @ViewChild('AlertInfluencerApiFail')
  alertInfluencerApiFail: AchooPopupComponent;
  @ViewChild('UpdateInfluencerGroupError')
  public updateInfluencerGroupError: AchooPopupComponent;
  @ViewChild('GroupDetailsBreadcumb')
  public groupDetailsBreadcumb: GroupDetailsBreadcumbComponent;
  @ViewChild('BottombarInfluencerFragement')
  public bottombarInfluencerFragement: BottombarInfluencerFragementComponent;
  @ViewChild('SelectAllInfluencers') selectAllInfluencers: AchooPopupComponent;

  @Input() influencerGroup: InfluencerGroup = new InfluencerGroup();

  public scrollDistance = CommonConstant.DEFAULT_INFINITE_SCROLL_DISTANCE;
  public scrollUpDistance = CommonConstant.DEFAULT_INFINITE_SCROLL_DISTANCE_UP;
  public throttle = CommonConstant.DEFAULT_INFINITE_SCROLL_THROTTLE;

  public influencerGroupId: number;
  // Keep previous influencer group and used in case update failed.
  private previousInfluencerGroup: InfluencerGroup = new InfluencerGroup();
  public influencerList: Influencer[] = [];
  public deleteInfluencers: any[] = [];
  public countryList: Country[] = [];
  private internationalCountry: Country;
  public platformList: Platform[] = [];
  public totalInfluencer = 0;
  private currentPageIndex: number = CommonConstant.START_PAGE_INDEX;
  public campaignList: any[];
  public influencerGroupList: any[];
  public pendingInfluencerList: Influencer[] = [];
  public selectedInfluencers: Influencer[] = [];

  // search criteria
  public searchCriteria: GroupSearch = new GroupSearch();
  // state of search bar
  public openSearchBar = false;

  // group details search supcription
  public groupSubscription: Subscription;
  // server error message
  public serverErrorMessage: string;
  // success message
  public successMessage: string;

  public activeBottomBar;

  // keep previous influencer list before adding or removing
  public previousPendingInfluencerList;
  public previousInfluencerList;

  public isActiveDiscoverFollower: boolean;

  private isFetchingNextInfluencerResult = false;
  private isWaitingNextInfluencerResult = false;
  public isRecentlyVisitedInfluencerGroup = false;
  private offsetId: number;
  public isRequestReview = false;
  public showFetchMoreBtn = false;
  public influencerGroupSetting: InfluencerGroup | NewInfluencerGroup;
  public isLoadingData = false;

  private selectAllInfluencerModalRef;

  constructor(public groupService: GroupService,
              protected userService: UserService,
              public route: ActivatedRoute,
              public router: Router,
              public referenceDataService: ReferenceDataService,
              public location: NgCommonLocation,
              public campaignService: CampaignService,
              public influencerGroupService: InfluencerGroupsService,
              public modalService: ModalService,
              public cacheService: CacheService,
              public placeholderVisibilityService: PlaceholderVisibilityService,
              public ngZone: NgZone,
              public eventTracker: EventTrackerService,
              public influencerService: InfluencerService,
              public translate: TranslateService) {
    super(userService);
    this.referenceDataService.loadDefinitions().subscribe((res: any) => {
      this.countryList = res.data.countries;
      this.platformList = res.data.platforms;
      this.internationalCountry = this.countryList.find(x => x.id === this.INTERNATIONAL_COUNTRY_ID);
    });
    this.isActiveDiscoverFollower = AppSettings.isEnableDiscoverFollower();
  }

  ngOnInit() {
    if (this.influencerGroup && this.influencerGroup.status && this.influencerGroup.status === InfluencerGroupStatus.PENDING) {
      return;
    }
    this.route.data.subscribe(data => {
      this.isRecentlyVisitedInfluencerGroup = data.isRecentlyVisitedInfluencerGroup ? data.isRecentlyVisitedInfluencerGroup : false;
    });
    super.ngOnInit();
    if (!this.isRecentlyVisitedInfluencerGroup) {
      this.loadNormalInfluencerGroupData();
      this.fetchPendingInfluencerList(false);
    } else {
      this.loadRecentlyVisitedInfluencerGroupData();
    }
    if (this.cacheService.hasValidCachedValue(`influencer_list_of_group_${this.influencerGroupId}`)) {
      this.cacheService.get(`influencer_list_of_group_${this.influencerGroupId}`).subscribe((res) => {
        this.influencerList = res;
        const influencerIds = this.influencerList.map(inf => inf.id);
        this.preloadInfluencerDetaisList(influencerIds, false);
      });
      this.cacheService.get(`influencer_list_of_group_${this.influencerGroupId}_scrollId`).subscribe(data => {
        this.searchCriteria.scrollId = data;
      });
    } else {
      this.fetchInfluencerListOfGroup(CommonConstant.START_PAGE_INDEX);
    }
    this.isRequestReview = AppSettings.isRequestReview();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.ngZone.runOutsideAngular(() => {
      if (document.documentElement.scrollTop > 0) {
        this.cacheService.set(`group_details_${this.influencerGroupId}_scroll_top`, document.documentElement.scrollTop);
      }
    });
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    setTimeout(() => {
      if (this.cacheService.has(`group_details_${this.influencerGroupId}_scroll_top`)) {
        this.cacheService.get(`group_details_${this.influencerGroupId}_scroll_top`).subscribe((pos) => {
          window.scrollTo(0, pos);
        });
      }
    }, 100);
  }

  private loadNormalInfluencerGroupData() {
    this.route.params.subscribe(params => {
      this.influencerGroupId = this.influencerGroupId ? this.influencerGroupId : +params['influencer_group_id'];
    });
    const groupKey = `influencer_group_${this.influencerGroupId}`;
    this.initializeSearchCriteria();
    this.cacheService.get(groupKey,
      this.groupService.getInfluencerGroup(this.influencerGroupId)).subscribe((res: any) => {
      this.influencerGroupSetting = res;
      if (this.influencerGroupSetting instanceof NewInfluencerGroup) {
        this.influencerGroup.influencer_group_id = this.influencerGroupSetting.id;
        this.influencerGroup.influencer_group_name = this.influencerGroupSetting.name;
        this.influencerGroup.influencer_group_description = this.influencerGroupSetting.description;
        this.influencerGroup.influencer_group_type_id = this.influencerGroupSetting.type;
      } else {
        this.influencerGroup = this.influencerGroupSetting;
      }
      this.previousInfluencerGroup = ObjectUtils.deepClone(this.influencerGroup);
      // no tracking if response is null
      if (!res) {
        return;
      }
      // segment track event view details group
      this.eventTracker.trackUserAction(UserActionType.VIEW, Page.GROUP, {
        id: this.influencerGroupId,
        name: res.influencer_group_name,
        type: Page.GROUP
      },
        undefined,
        undefined,
      {
        type: ActivePages.GROUP_DETAILS,
        name: res.influencer_group_name,
        id: this.influencerGroupId
      }
      );
    });
    this.influencerService.cancelCurrentPreloadingRequest();
  }

  private loadRecentlyVisitedInfluencerGroupData() {
    this.influencerGroup.influencer_group_name = RecentlyVisitedInfluencerGroup.name;
    this.influencerGroup.influencer_group_description = RecentlyVisitedInfluencerGroup.description;
    // segment track event view recently visited influencer group
    this.eventTracker.trackUserAction(UserActionType.VIEW, Page.RECENTLY_VIEWED_INFLUENCERS_GROUP,
      undefined,
      undefined,
      undefined,
      undefined
    );
  }

  private initializeSearchCriteria() {
    this.route.queryParams.subscribe(params => {
      const formatedParams = {};
      Object.keys(params).forEach((key) => {
        // should not take into account default param
        if (key !== 'activeAccount' && key !== 'searchString') {
          this.openSearchBar = true;
        }
        const rawValue = params[key];
        if (isNaN(rawValue)) {
          formatedParams[key] = rawValue;
        } else {
          formatedParams[key] = Number(rawValue);
        }
      });

      this.searchCriteria = Object.assign({}, this.searchCriteria, formatedParams);
    });
  }

  companyChangeCallback(companyId) {
    this.campaignService.getCampaignShortListForCompany(companyId).subscribe((res: any) => {
      this.campaignList = res ? res.filter(campaignItem => campaignItem.status !== CampaignInfluencerStatus.ARCHIVED).map(
        (campaign) => ({
          id: campaign.id,
          name: campaign.name,
          brief: campaign.brief
        })
      ) : [];
    });

    // load list influencer group
    this.influencerGroupService.getInfluencerGroupShortList(companyId).subscribe((res: any) => {
      this.influencerGroupList = res.map(group => ({
        id: group.id,
        name: group.name,
        description: group.description
      }));
      if (!this.isRecentlyVisitedInfluencerGroup && !this.influencerGroupList.find(group => group.id === this.influencerGroupId)) {
        this.router.navigate(['/groups']);
      }
    });
  }


  ngOnDestroy() {
    super.ngOnDestroy();
    this.cancelPendingRequest();
    this.cacheService.clear(GroupDetailsComponent.INFLUENCER_DETAILS_LIST_KEY);
  }

  public beforeActiveBottomBar() {
    if (this.influencerGroup.status === InfluencerGroupStatus.PENDING) {
      return;
    }
    this.activeBottomBar = 'active';
  }

  public closeBottonBar(evt?) {
    if (evt && evt.bulkUploadInfluencers) {
      // this is for optimistic ui when adding bulk influencers
      this.isLoadingData = true;
      const newAddedInfluencer = this.updateInfluencerGroupList(evt.bulkUploadInfluencers);
      this.influencerList = newAddedInfluencer.reverse().concat(...this.influencerList);
      this.totalInfluencer = this.influencerList.length;
    }
    if (evt && evt.isReloadInfluencerList) {
      this.reloadInfluencerList();
    }
    if (this.activeBottomBar === 'active') {
      this.activeBottomBar = 'inactive';
    }
  }

  private updateInfluencerGroupList(data) {
    return data.map(item => {
      const mappedInfluencerItem: Influencer = new Influencer();
      mappedInfluencerItem.influencer_id = 0;
      mappedInfluencerItem.influencer_name = item.handle;
      mappedInfluencerItem.country = this.countryList[103];
      mappedInfluencerItem.country_code = CommonConstant.INTERNATIONAL_COUNTRY_DATA.code;
      mappedInfluencerItem.country_name = CommonConstant.INTERNATIONAL_COUNTRY_DATA.name;
      mappedInfluencerItem.platform = item.platform;
      mappedInfluencerItem.isNewAdded = true;
      mappedInfluencerItem.isPending = false;
      return mappedInfluencerItem;
    });
  }

  public deleteInfluencerFromBottomBar(evt) {
    this.deleteInfluencers = evt.influencerToDelete;
    this.deleteSelectedInfluencers();
  }

  public deleteSelectedInfluencers() {
    const selectedInfluencerToDeleteIds = this.deleteInfluencers.map((influencer) => influencer.influencer_id);
    this.deleteMultipleInfluencers(selectedInfluencerToDeleteIds);
    this.closeWarningDeleteInfluencerPopup();
  }

  showWarningDeleteInfluencerPopup(influencers: any[]) {
    this.deleteInfluencers = influencers;
    this.modalService.openInCenter(this.warningDeleteInfluencerDialog);
  }

  onRejectSuggestedInfluencer(influencer) {
    // optimistic UI, add influencer immediately
    this.updateInfluencerList(influencer, true);
    // call API to delete server side
    this.groupService.deleteInfluencerOfGroup([influencer.id], this.influencerGroupId, this.companyId)
      .subscribe((res: any) => {
        // do nothing
      }, (error) => {
        // revert previous list when error occurred
        this.pendingInfluencerList = this.previousPendingInfluencerList;
        // show error message
        this.serverErrorMessage = this.translate.instant('group_details.influencer.delete_influencer_error');
        this.modalService.open(this.serverErrorNotification, this.beforeClearErrorNotif.bind(this), true);
      });
  }

  approveNewInfluencer(influencer) {
    // optimistic UI, add influencer immediately
    this.updateInfluencerList(influencer);
    // call API to update server side
    this.groupService.approveInfluencerInGroup([influencer.id], this.influencerGroupId, this.companyId).subscribe((res) => {
      this.sendMixpanelWhenApproveInfluencer(influencer, null);
      this.eventTracker.trackUserAction(UserActionType.CHAM_ADD_INFLUENCER_TO_GROUP);
    }, (error) => {
      // revert previous list when error occurred
      this.pendingInfluencerList = this.previousPendingInfluencerList;
      this.influencerList = this.previousInfluencerList;
      this.totalInfluencer = this.totalInfluencer - 1;
      this.hanldeUnexpectedError();
    });
  }

  updateInfluencerList(influencer, isRemoved = false) {
    // keep the current list to revert when API fails
    this.previousPendingInfluencerList = ObjectUtils.deepClone(this.pendingInfluencerList);
    this.previousInfluencerList = ObjectUtils.deepClone(this.influencerList);
    if (isRemoved) {
      this.pendingInfluencerList = this.pendingInfluencerList.filter(infl => infl.id !== influencer.id);
    } else {
      const approvedInfluencer = this.pendingInfluencerList.find(infl => infl.id === influencer.id);
      approvedInfluencer.isPending = false;
      this.influencerList.unshift(approvedInfluencer);
      this.totalInfluencer += 1;
      this.pendingInfluencerList = this.pendingInfluencerList.filter(inf => inf.id !== influencer.id);
    }
  }

  searchInfluencerByText(str) {
    if (str && str !== '') {
      this.searchCriteria.searchString = str;
    } else {
      this.searchCriteria.searchString = undefined;
    }
    this.advanceSearchInfluencerList(new GroupSearch());
  }

  advanceSearchInfluencerList(groupSearch: GroupSearch) {
    this.searchCriteria = Object.assign({}, this.searchCriteria, groupSearch);
    this.searchCriteria.scrollId = undefined;
    this.updateSearchCriteriaOnLink(this.searchCriteria);
    this.fetchInfluencerListOfGroup(CommonConstant.START_PAGE_INDEX, false);
  }

  selectAllInfluencer(e) {
    if (e) {
      this.influencerList.filter(infl => !infl.isPending).forEach((influencer) => {
        influencer.selected = true;
      });
      this.trackSelectingInfluencerEvent();
      this.showNotificationSelectAll();
    } else {
      this.influencerList.filter(infl => !infl.isPending).forEach((influencer) => {
        influencer.selected = false;
      });
      this.closeNotificationSelectAll();
    }
  }

  onSelectSingleInfluencer(selectedInfluencer) {
    this.influencerList.forEach((influencer) => {
      if (influencer.influencer_id === selectedInfluencer.influencer_id) {
        influencer.selected = !influencer.selected;
        if (influencer.selected) {
          this.selectedInfluencers.push(influencer);
        }
      }
    });
    if (selectedInfluencer.selected === true) {
      this.trackSelectingInfluencerEvent(selectedInfluencer);
    }
  }

  private trackSelectingInfluencerEvent(selectedInfluencer?) {
    // track event to Segment
    this.eventTracker.trackUserAction(UserActionType.ACTION, Page.GROUP, {
      id: selectedInfluencer && selectedInfluencer.influencer_id || '*',
      name: selectedInfluencer && selectedInfluencer.influencer_name || 'all',
      type: TargetType.INFLUENCER
    }, {
      action: UserActionType.SELECTION,
      source: ActionSource.PAGE
    }, undefined, {
      type: ActivePages.GROUP_DETAILS,
    });
  }

  closeWarningDeleteInfluencerPopup() {
    this.deleteInfluencers = [];
    this.modalService.close();
  }

  onScrollDown() {
    if (this.isFetchingNextInfluencerResult && !this.isRecentlyVisitedInfluencerGroup) {
      this.isWaitingNextInfluencerResult = true;
    } else {
      this.currentPageIndex++;
      this.fetchInfluencerListOfGroup(this.currentPageIndex, true);
    }
  }

  reloadInfluencerList(isLoadMore = false) {
    this.searchCriteria.scrollId = undefined;
    this.fetchInfluencerListOfGroup(CommonConstant.START_PAGE_INDEX, isLoadMore);
  }

  get numberInfluencerToDelete() {
    return this.deleteInfluencers.length;
  }

  get previewInfluencerList() {
    const activeInfluencerIds = this.influencerList.map(infl => infl.id);
    const hiddenSelectedInfluencers = this.selectedInfluencers.filter(si => activeInfluencerIds.indexOf(si.id) < 0);
    return this.influencerList.concat(...hiddenSelectedInfluencers);
  }

  private loadInfluencerListOfGroup(groupSearch: GroupSearch, isLoadMore: boolean) {
    // remove undefined request param
    Object.keys(groupSearch).forEach(key => {
      if (groupSearch[key] === undefined) {
        delete groupSearch[key];
      }
    });
    this.placeholderVisibilityService.show(CommonConstant.GROUP_DETAILS_PLACEHOLDER);
    if (!this.isRecentlyVisitedInfluencerGroup) {
      this.getInfluencerListByGroupId(groupSearch, isLoadMore);
    } else {
      this.getMonthlyVisitInfluencer(groupSearch.limit, isLoadMore);
    }
  }

  private getInfluencerListByGroupId(groupSearch, isLoadMore) {
    // stop loading if group id is undefined
    if (!this.influencerGroupId) {
      return;
    }
    const groupId = this.influencerGroupId.toString();
    this.groupSubscription = this.groupService.getInfluencerListByGroupId(groupSearch, groupId).subscribe((res: any) => {
      this.isFetchingNextInfluencerResult = false;
      if (!res.data || !res.data.influencers) {
        this.placeholderVisibilityService.hide(CommonConstant.GROUP_DETAILS_PLACEHOLDER);
        return;
      }
      const addedInfluencerList = this.mapInfluencerData(res.data.influencers);
      const selectedInfluencerIds = this.selectedInfluencers.map(si => si.id);
      addedInfluencerList.forEach(infl => infl.selected = selectedInfluencerIds.indexOf(infl.id) >= 0);
      const influencerList = addedInfluencerList;

        // update lasted sort value for pagination
      this.updateScrollId(res.data.scrollId);
      this.cacheService.set(`influencer_list_of_group_${this.influencerGroupId}_scrollId`, res.data.scrollId);

      this.reloadInfluencerData(influencerList, isLoadMore);

      this.cacheService.set(`influencer_list_of_group_${this.influencerGroupId}`, this.influencerList);
      // preload influencer details data
      const influencerIds = influencerList.map(inf => inf.id);
      this.preloadInfluencerDetaisList(influencerIds, isLoadMore);

      this.totalInfluencer = isLoadMore ? this.totalInfluencer : res.data.totalInfluencers;
      this.placeholderVisibilityService.hide(CommonConstant.GROUP_DETAILS_PLACEHOLDER);
    });
  }

  private getMonthlyVisitInfluencer(limit, isLoadMore) {
    if (this.influencerList && this.influencerList.length === 0) {
      this.offsetId = 0;
    } else {
      this.offsetId = this.influencerList[this.influencerList.length - 1].offsetId;
    }
    this.groupService.getMonthlyVisitInfluencer(this.companyId, limit, this.offsetId).subscribe((res) => {
      if (!res || !res.influencers) {
        this.placeholderVisibilityService.hide(CommonConstant.GROUP_DETAILS_PLACEHOLDER);
        return;
      }
      const influencerList = this.mapInfluencerData(res.influencers);
      this.reloadInfluencerData(influencerList, isLoadMore);
      this.totalInfluencer = res.total;
      this.placeholderVisibilityService.hide(CommonConstant.GROUP_DETAILS_PLACEHOLDER);
    }, (error) => {
      Sentry.captureException(new Error('Failed to load Recently Viewed influencers'));
      this.modalService.openInCenter(this.alertInfluencerApiFail, undefined);
    });
  }

  private reloadInfluencerData(influencerList, isLoadMore) {
    if (this.isWaitingNextInfluencerResult) {
      this.influencerList.push(...influencerList);
      this.isWaitingNextInfluencerResult = false;
      // start fetching the next pending result
      this.currentPageIndex += 1;
      this.fetchInfluencerListOfGroup(this.currentPageIndex, true);
    } else if (isLoadMore) {
      if (!this.isRecentlyVisitedInfluencerGroup) {
        this.influencerList.push(...influencerList);
      } else {
        this.influencerList = this.influencerList.concat(influencerList.filter(listItem => this.influencerList.every(item => item.id !== listItem.id)));
      }
    } else if (this.isLoadingData) {
      this.influencerList = this.updateNewAddedInfluencerItem(influencerList);
      this.isLoadingData = false;
    } else {
      this.influencerList = influencerList;
    }
  }

  private updateNewAddedInfluencerItem(influencerList) {
    const result = [];
    const addedInfluencerIds = new Set<number>();

    this.influencerList.forEach(item => {
      if (item.influencer_id === 0) {
        const newAddedItem = influencerList.find(influencerListItem => influencerListItem.influencer_name === item.influencer_name);

        if (newAddedItem) {
          this.pushInfluencerToArrayIfNotExist(result, addedInfluencerIds, newAddedItem);
        }

        return;
      }

      this.pushInfluencerToArrayIfNotExist(result, addedInfluencerIds, item);
    });

    // Traverse added influencer list from API one more time because we still have the case that influencer name change after uploaded
    influencerList.forEach(newAddedItem => this.pushInfluencerToArrayIfNotExist(result, addedInfluencerIds, newAddedItem));

    return result;
  }

  private pushInfluencerToArrayIfNotExist(desArray: any[], cacheIds: Set<number>, influencer: any): void {
    if (cacheIds.has(influencer.influencer_id)) { return; }

    desArray.push(influencer);
    cacheIds.add(influencer.influencer_id);
  }

  private mapInfluencerData(rawInfluencerList, isPendingList?: boolean) {
    if (!rawInfluencerList) {
      return [];
    }
    return rawInfluencerList.map(inf => {
      this.setDefaultCountry(inf);

      return {
        isPending: isPendingList ? true : false,
        id: inf.influencerId,
        influencer_group_id: inf.groupId,
        company_id: inf.companyId,
        influencer_id: inf.influencerId,
        influencer_name: inf.influencerName,
        influencer_image: inf.profilePicture,
        country: inf.country ? inf.country.name : null,
        country_code: inf.country ? inf.country.code : null,
        language: {
          name: inf.language ? inf.language.name : null,
          code: inf.language ? inf.language.code : null,
          id: inf.language ? inf.language.id : null,
        },
        platform: inf.platforms,
        reach: inf.reach,
        engagement: inf.engagement,
        impression: inf.impression,
        impact: inf.impact,
        numberOfPosts: inf.numberOfPosts,
        numberOfFollowers: inf.numberOfFollowers,
        topMention: inf.topMentions,
        channels: inf.channels,
        favoriteTopics: inf.favouriteTopics ? inf.favouriteTopics.join(', ') : null,
        offsetId: inf.id
      };
    });
  }

  public fetchInfluencerListOfGroup(currentPageIndex: number, isLoadMore = false) {
    this.isFetchingNextInfluencerResult = true;
    // cancel previous request
    this.cancelPendingRequest();
    // calculation offset
    this.searchCriteria.limit = CommonConstant.PAGINATION_INFLUENCER_SIZE;
    this.searchCriteria.offset = (currentPageIndex - 1) * CommonConstant.PAGINATION_INFLUENCER_SIZE;
    // perform search
    this.loadInfluencerListOfGroup(this.searchCriteria, isLoadMore);
    if (!this.isRecentlyVisitedInfluencerGroup) {
      this.fetchPendingInfluencerList(isLoadMore);
    }
  }

  private deleteMultipleInfluencers(influencerToDeleteIds: number[]) {
    const currentCompanyId = this.userService.getCompanyId();
    // keep removed indexs and remove influencer on UI immediately
    const deletedInfluencerIndexMap = new Map();
    this.deleteInfluencers.forEach((di) => {
      const removingIndex = this.influencerList.findIndex(inf => inf.id === di.id);
      deletedInfluencerIndexMap.set(di.id, removingIndex);
      this.influencerList.splice(removingIndex, 1);
    });
    this.groupService.deleteInfluencerOfGroup(influencerToDeleteIds, this.influencerGroupId, currentCompanyId)
      .subscribe((res: any) => {
        this.modalService.close();
        const deleteInfluencers = this.deleteInfluencers.map((influencer) => ({
          id: influencer.influencer_id,
          name: influencer.influencer_name,
        }));
        this.deleteInfluencers = [];
        this.totalInfluencer = this.totalInfluencer - influencerToDeleteIds.length;
        this.reloadInfluencerList();
        // track event to Segment
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.GROUP, {
          id: this.influencerGroup.influencer_group_id,
          name: this.influencerGroup.influencer_group_name,
          type: TargetType.INFLUENCER_GROUP
        }, {
          action: UserActionType.UPDATE,
          actionDetails: ActionDetails.REMOVED_INFLUENCERS,
          source: ActionSource.PAGE,
          influencers: deleteInfluencers
        }, undefined, {
          type: ActivePages.GROUP_DETAILS,
          id: this.influencerGroup.influencer_group_id,
          name: this.influencerGroup.influencer_group_name
        });
      }, (error) => {
        // handle error, revert deleted influencer in correct position
        this.deleteInfluencers.forEach((di) => {
          this.influencerList.splice(deletedInfluencerIndexMap.get(di.id), 0, di);
        });
        // show error message
        this.serverErrorMessage = this.translate.instant('group_details.influencer.delete_influencer_error');
        this.modalService.open(this.serverErrorNotification, this.beforeClearErrorNotif.bind(this), true);
      });
  }

  private beforeClearErrorNotif() {
    this.serverErrorMessage = null;
  }

  public cancelPendingRequest() {
    if (this.groupSubscription) {
      this.groupSubscription.unsubscribe();
    }
    this.placeholderVisibilityService.hideImmediately(CommonConstant.GROUP_DETAILS_PLACEHOLDER);
  }

  /**
   * Update pagination values
   */
  private updateScrollId(scrollId: string) {
    this.searchCriteria.scrollId = undefined;
    if (scrollId) {
      this.searchCriteria.scrollId = scrollId;
    }
  }

  private updateSearchCriteriaOnLink(criteria: GroupSearch) {
    const cloneCriteria: GroupSearch = new GroupSearch();
    cloneCriteria.selectedCountry = criteria.selectedCountry;
    cloneCriteria.selectedGender = criteria.selectedGender;
    cloneCriteria.selectedPlatform = criteria.selectedPlatform;

    if (criteria.reachFrom && criteria.reachFrom > 0) {
      cloneCriteria.reachFrom = criteria.reachFrom;
    }
    if (criteria.reachFrom && criteria.reachFrom > 0) {
      cloneCriteria.reachFrom = criteria.reachFrom;
    }
    if (criteria.reachTo && criteria.reachTo !== 1000000) {
      cloneCriteria.reachTo = criteria.reachTo;
    }
    if (criteria.engagementFrom && criteria.engagementFrom > 0) {
      cloneCriteria.engagementFrom = criteria.engagementFrom;
    }
    if (criteria.engagementTo && criteria.engagementTo !== 1000000) {
      cloneCriteria.engagementTo = criteria.engagementTo;
    }
    if (criteria.impactFrom && criteria.impactFrom > 0) {
      cloneCriteria.impactFrom = criteria.impactFrom;
    }
    if (criteria.impactTo && criteria.impactTo < 100) {
      cloneCriteria.impactTo = criteria.impactTo;
    }
    if (criteria.searchString && criteria.searchString !== '') {
      cloneCriteria.searchString = criteria.searchString;
    }

    const queries = Object.assign({}, cloneCriteria, {
      activeAccount:  this.userService.getCompanyId()
    });
    const url = this.router
      .createUrlTree([`/groups/${this.influencerGroupId}`], { queryParams: queries })
      .toString();

    this.location.replaceState(url.toString());
  }

  private preloadInfluencerDetaisList(influencerIds, isLoadMore) {
    this.influencerService.preloadInfluencerDataByIdList(influencerIds, null, isLoadMore);
  }

  // Fallback to "International" if country is nil
  private setDefaultCountry(inf): void {
    if (!inf.country) {
      inf.country = this.internationalCountry;
    }
  }

  backToPreviousPage() {
    this.location.back();
  }

  closeErrorMsgModal() {
    this.modalService.close();
  }

  fetchPendingInfluencerList(isLoadMore = true) {
    this.getPendingInfluencerList(isLoadMore);
  }

  private getPendingInfluencerList(isLoadMore, limit = 20) {
    // stop processing if group id is undefined
    if (!this.influencerGroupId) {
      return;
    }
    let lastSeenId;
    if (!isLoadMore || (this.pendingInfluencerList && this.pendingInfluencerList.length === 0)) {
      lastSeenId = 0;
    } else {
      lastSeenId = this.pendingInfluencerList[this.pendingInfluencerList.length - 1].offsetId;
    }
    this.groupService.getPendingInfluencerList(this.influencerGroupId, limit, lastSeenId).subscribe((res) => {
      const pendingList = this.mapInfluencerData(res.influencers, true);
      if (isLoadMore) {
        this.pendingInfluencerList = this.pendingInfluencerList.concat(pendingList.filter(listItem => this.pendingInfluencerList.every(item => item.id !== listItem.id)));
      } else {
        this.pendingInfluencerList = pendingList;
      }
      this.showFetchMoreBtn = this.pendingInfluencerList.length < res.total && !this.isRecentlyVisitedInfluencerGroup ? true : false;
    }, (error) => {
      WebUtils.reportErrorToSentry('Failed to load Pending Influencers List', error);
      this.modalService.openInCenter(this.alertInfluencerApiFail, undefined);
    });
  }

  get showEmptyResultMessage() {
    return this.influencerList.length === 0 && this.pendingInfluencerList.length === 0;
  }

  get numberOfSelectedInfluencers() {
    if (!Array.isArray(this.influencerList)) {
      return 0;
    }

    return this.influencerList.filter(inf => inf.selected).length;
  }

  private hanldeUnexpectedError() {
    this.serverErrorMessage = this.translate.instant('group_details.influencer.approve_influencer_error');
    this.modalService.open(this.serverErrorNotification, null, true);
  }

  private sendMixpanelWhenApproveInfluencer(influencer, limitInfo) {
    if (!limitInfo) {
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.GROUP, {
        id: this.influencerGroup.influencer_group_id,
        name: this.influencerGroup.influencer_group_name,
        type: TargetType.INFLUENCER_GROUP
      }, {
        action: UserActionType.UPDATE,
        actionDetails: ActionDetails.ADDED_INFLUENCERS,
        source: ActionSource.PENDING_LIST,
        influencer: influencer
      }, undefined, null);
    } else {
      const detailAction = new InvalidAction(true, limitInfo.blockedReason, limitInfo.wallType, limitInfo.wallName, true,
        limitInfo.maxValue, limitInfo.desiredValue, this.userService.accountLevelName);
      this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.ACTION, Page.GROUP, {
        id: this.influencerGroup.influencer_group_id,
        name: this.influencerGroup.influencer_group_name,
        type: TargetType.INFLUENCER_GROUP
      }, {
        action: UserActionType.UPDATE,
        actionDetails: ActionDetails.ADDED_INFLUENCERS,
        source: ActionSource.PENDING_LIST,
        influencer: influencer
      }, undefined, null);
    }
  }

  beforeAddingPendingInfluencerToGroup(evt) {
    if (!evt || (evt && evt.length === 0)) {
      return;
    }
    this.previousPendingInfluencerList = ObjectUtils.deepClone(this.pendingInfluencerList);
    const newAddedPendingInfluencer = this.mapInfluencerData(evt, true);
    this.pendingInfluencerList = this.pendingInfluencerList.concat(newAddedPendingInfluencer);
  }

  addPendingInfluencerToGroupError() {
    this.pendingInfluencerList = this.previousPendingInfluencerList;
  }
  get activePage(): ActivePage {
    return {
      type: ActivePages.GROUP_DETAILS
    };
  }

  updateGroupEvent(evt) {
    const influencerGroup = new InfluencerGroup();
    influencerGroup.influencer_group_id = evt.influencer_group_id;
    influencerGroup.influencer_group_name = evt.influencer_group_name;
    influencerGroup.influencer_group_description = evt.influencer_group_description;
    influencerGroup.influencer_group_type = evt.influencer_group_type_id;
    this.bottombarInfluencerFragement.influencerGroup = influencerGroup;
    this.bottombarInfluencerFragement.showCreateNewGroupFragment = true;
    this.bottombarInfluencerFragement.temporaryHidden = false;
    this.beforeActiveBottomBar();
  }

  beforeUpdateGroupEvent(evt) {
    if (!evt || !evt.influencerGroupId || evt.influencerGroupId !== this.influencerGroup.influencer_group_id) {
      return;
    }
    this.influencerGroup.influencer_group_name = evt.influencerGroupName;
    this.influencerGroup.influencer_group_description = evt.influencerGroupDescription;
    this.groupDetailsBreadcumb.elementPaths[this.groupDetailsBreadcumb.elementPaths.length - 1].name = evt.influencerGroupName;
    this.bottombarInfluencerFragement.temporaryHidden = true;
    this.closeBottonBar();
  }

  afterUpdateGroupEvent(evt) {
    if (!evt.isError) {
      this.bottombarInfluencerFragement.showCreateNewGroupFragment = false;
      this.sendUpdateGroupNameEvent(evt.data);
      if (this.influencerGroupSetting instanceof NewInfluencerGroup) {
        this.influencerGroupSetting.name = evt.data.influencerGroupName;
      } else {
        this.influencerGroupSetting.influencer_group_name = evt.data.influencerGroupName;

      }
    } else {
      this.handleUpdateGroupError();
    }
  }

  private sendUpdateGroupNameEvent(influencerGroupData) {
    this.eventTracker.trackUserAction(UserActionType.ACTION, Page.INFLUENCER_GROUP, {
      id: influencerGroupData.influencerGroupId,
      name: influencerGroupData.influencerGroupName,
      type: Page.INFLUENCER_GROUP
    }, {
      actionDetails: ActionDetails.UPDATED_DETAILS,
      source: ActionSource.ACTION_VIEW,
      action: UserActionType.UPDATE,
      ...influencerGroupData
    }, undefined, null, null);
  }

  private handleUpdateGroupError() {
    // Revert data
    this.influencerGroup = ObjectUtils.deepClone(this.previousInfluencerGroup);
    this.groupDetailsBreadcumb.elementPaths[this.groupDetailsBreadcumb.elementPaths.length - 1].name = this.previousInfluencerGroup.influencer_group_name;
    this.bottombarInfluencerFragement.influencerGroup.influencer_group_name = this.influencerGroup.influencer_group_name;
    this.bottombarInfluencerFragement.influencerGroup.influencer_group_description = this.influencerGroup.influencer_group_description;
    // Display bottom bar
    this.beforeActiveBottomBar();
    this.bottombarInfluencerFragement.temporaryHidden = false;
    this.bottombarInfluencerFragement.showCreateNewGroupFragment = true;
    this.modalService.open(this.updateInfluencerGroupError, null, true);
  }

  editOrCreateProject(project) {
    this.beforeActiveBottomBar();
    this.bottombarInfluencerFragement.showCreateProjectFragement(project, false);
  }

  showHideGroupSettings() {
    if (!this.groupDetailsBreadcumb) {
      return;
    }
    if (this.groupDetailsBreadcumb.showGroupSetting) {
      this.groupDetailsBreadcumb.closeSetting();
    } else {
      this.groupDetailsBreadcumb.editInfluencerGroupSetting();
    }
  }

  clearSelectedInfluencers() {
    this.selectedInfluencers = [];
  }

  protected showNotificationSelectAll() {
    this.selectAllInfluencerModalRef = this.modalService.open(this.selectAllInfluencers, null, true);
  }

  protected closeNotificationSelectAll() {
    if (this.selectAllInfluencerModalRef) {
      this.modalService.closeSinglePopup(this.selectAllInfluencerModalRef);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/group-details/group-details.component.ts